import React from "react";

import {
  NavLink
} from "react-router-dom";

import {
  FaUsers,
  FaTimes
} from "react-icons/fa";

import "../styles/AdminSidebar.css";


const AdminSidebar = ({
  isOpen,
  onClose
}) => {

  return (
    <aside
      className={
        `admin-sidebar ${
          isOpen ? "open" : ""
        }`
      }
    >

      <div className="admin-sidebar-header">

        <div>
          <h2>
            CarrerUp
          </h2>

          <span>
            Administration
          </span>
        </div>


        <button
          type="button"
          className="admin-sidebar-close"
          onClick={onClose}
          aria-label="Fermer le menu"
        >
          <FaTimes />
        </button>

      </div>


      <nav className="admin-sidebar-nav">

        <NavLink
          to="/admin/users"
          onClick={onClose}
          className={({ isActive }) =>
            isActive
              ? "admin-sidebar-link active"
              : "admin-sidebar-link"
          }
        >
          <FaUsers />

          <span>
            Liste des utilisateurs
          </span>
        </NavLink>

      </nav>

    </aside>
  );
};

export default AdminSidebar;